import React, { useState } from 'react';
import { Alert, Button } from 'reactstrap';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';

const DefaultAlert = ({
  className,
  color,
  msg,
  buttonText,
  onClickButton,
  closeAfterButtonClick,
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(true);

  return (
    <Alert
      className={`p-1 d-block d-md-flex ${className}`}
      color={color ? color : 'success'}
      isOpen={isVisible}
      {...props}
    >
      <span className="align-self-center">
        <Icon.AlertCircle size={20} className={color} />
      </span>
      <span className="mr-md-2 align-self-center">{msg}</span>
      {buttonText && (
        <div className="align-items-stretch mt-1 mt-md-0">
          <Button.Ripple
            block
            size="md"
            color={color}
            className="mb-0 w-100"
            onClick={() => {
              if (onClickButton) onClickButton();
              if (closeAfterButtonClick) setIsVisible(false);
            }}
          >
            <span className="text-nowrap">{buttonText}</span>
          </Button.Ripple>
        </div>
      )}
    </Alert>
  );
};

DefaultAlert.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  msg: PropTypes.string,
  buttonText: PropTypes.string,
  onClickButton: PropTypes.func,
  closeAfterButtonClick: PropTypes.func,
};

export default DefaultAlert;
